import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {ThemeState} from './InitialStatePropsModel'

const savedTheme = localStorage.getItem('theme') as 'light' | 'dark';

const initialState: ThemeState = {
  theme: savedTheme || 'light', // Load from localStorage or default to 'light'
};

const ThemeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state, action:PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload;
      localStorage.setItem('theme', action.payload);
    },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload;
      localStorage.setItem('theme', action.payload);
    },
  },
});

export const { toggleTheme, setTheme } = ThemeSlice.actions;

export default ThemeSlice;
